import "./Ourpartners.css";
// import bgimage from "../Assessts/partner11.png";
// import bgimage from "../Assessts/partner12.png";
// import bgimage from "../Assessts/partner1.jpg";
import bgimage from "../Assessts/partners2.png";

import { useState } from "react";

export default function OurPartners() {
  const partners = [
    "https://tcsas.in/wp-content/uploads/2022/04/download-300x98.jpg",
    "https://tcsas.in/wp-content/uploads/2022/04/force_logo_220.png",
    "https://tcsas.in/wp-content/uploads/2022/04/download-5.png",
    "https://tcsas.in/wp-content/uploads/2022/04/download-4-300x107.png",
    "https://tcsas.in/wp-content/uploads/2022/04/download-3-300x112.png",
    "https://tcsas.in/wp-content/uploads/2022/04/t_logo.gif",
    "https://tcsas.in/wp-content/uploads/2022/04/W1815571002C8BB93.png",
    "https://tcsas.in/wp-content/uploads/2022/04/download-1-300x90.jpg",
    "https://tcsas.in/wp-content/uploads/2022/04/download-2-300x124.jpg",
    "https://tcsas.in/wp-content/uploads/2022/04/download-6-300x111.png",
    "https://tcsas.in/wp-content/uploads/2022/04/logo208181.jpg",
    "https://tcsas.in/wp-content/uploads/2022/04/logo_new2-300x115.jpg",
    "https://tcsas.in/wp-content/uploads/2022/04/download-10-300x120.png",
    "https://tcsas.in/wp-content/uploads/2022/04/download-9.png",
    "https://tcsas.in/wp-content/uploads/2022/04/download-8-300x160.png",
    "https://tcsas.in/wp-content/uploads/2022/04/download-7-300x80.png",
    "https://tcsas.in/wp-content/uploads/2022/04/CMLGenLogo_Black-Blue3-300x72-1.png",
    "https://tcsas.in/wp-content/uploads/2022/04/43846.png",
    "https://tcsas.in/wp-content/uploads/2022/04/ftech_logo_small-150x90-1.png",
    "https://tcsas.in/wp-content/uploads/2022/04/halo-logo-1-300x106.gif",
    "https://tcsas.in/wp-content/uploads/2022/04/kontron-st-group_logo@2x-300x84.png",
    "https://tcsas.in/wp-content/uploads/2022/04/logo-1-300x105.png",
    "https://tcsas.in/wp-content/uploads/2022/04/logo-2-300x81.png",
    "https://tcsas.in/wp-content/uploads/2022/04/logo-300x102.jpg",
    "https://tcsas.in/wp-content/uploads/2022/04/logo.png",
    "https://tcsas.in/wp-content/uploads/2022/04/logo-580x200-1-300x103.png",
    "https://tcsas.in/wp-content/uploads/2022/04/logo-amphenol-socapex-300x40.png",
    "https://tcsas.in/wp-content/uploads/2022/04/logo-lantronix@2x-300x48.png",
    "https://tcsas.in/wp-content/uploads/2022/04/W1815571002C8BB93-1.png",
    "https://tcsas.in/wp-content/uploads/2022/04/rochester-electronics.png",
    "https://tcsas.in/wp-content/uploads/2022/04/download-11-300x150.png",
    "https://tcsas.in/wp-content/uploads/2022/04/download-2-1-300x120.png",
    "https://tcsas.in/wp-content/uploads/2022/04/th.jpg",
    "https://tcsas.in/wp-content/uploads/2022/04/apitech_logo-300x105.png",
    "https://tcsas.in/wp-content/uploads/2022/04/ADV_logo_small-300x100.jpg",
    "https://tcsas.in/wp-content/uploads/2022/04/ARA2020_fullcolorlogo-Edited-200x93-1.png",
    "https://tcsas.in/wp-content/uploads/2022/04/ue-300x240.png",
    "https://tcsas.in/wp-content/uploads/2022/04/dewesoft_logo-1-300x48.jpg",
    "https://tcsas.in/wp-content/uploads/2022/04/a5Q3b0000000NhnEAE_a5S3b0000002jnOEAQ-300x82.png",
  ];

  const [formData, setFormData] = useState({
    firmName: "",
    contact: "",
    products: "",
    delivery: "",
    interested: "",
    remarks: "",
  });

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Form submitted successfully!");
    console.log(formData);
  };

  return (
    <div className="ourpartners-container">
      {/* Hero Section */}
      <div className="ourpartners-hero">
        <img src={bgimage} alt="Our Partners" className="ourpartners-hero-image" />
        <div className="ourpartners-hero-text">
          <h1>Our Partners</h1>
          <p>
            <span>Home</span> / <span>Partners</span>
          </p>
        </div>
      </div>

      {/* Title */}
      <h1>
        <span>Our Partners</span>
      </h1>

      {/* Description */}
      <div
        style={{
          marginTop: "30px",
          maxWidth: "80%",
          marginLeft: "auto",
          marginRight: "auto",
          textAlign: "justify",
          lineHeight: "1.8",
          fontSize: "17px",
          color: "#333",
        }}
      >
        <p>
          <b>Technocrat Aerospace & Defence</b> has built strong strategic
          partnerships with leading <b>innovators</b> and <b>manufacturers</b>
          worldwide. These collaborations enable the company to supply and
          integrate <b>advanced sensors</b>, <b>precision encoders</b>,
          <b> robust connectors</b>, and a wide range of
          <b> mission-critical electronic components</b>. This partnership
          approach ensures Technocrat Aerospace & Defence can deliver
          <b> cutting-edge aerospace</b> and <b>defence technologies</b>,
          reinforcing its position as a <b>leading manufacturer</b> and
          <b> system integrator</b> in the industry.
        </p>
      </div>

      {/* 💼 Become a Partner Form */}
      <div className="partner-form-container">
        <h2>🤝 Become a Partner</h2>
        <form onSubmit={handleSubmit} className="partner-form">
          <label>
            Firm Name:
            <input
              type="text"
              name="firmName"
              value={formData.firmName}
              onChange={handleChange}
              required
            />
          </label>

          <label>
            Contact Details:
            <input
              type="text"
              name="contact"
              value={formData.contact}
              onChange={handleChange}
              required
            />
          </label>

          <label>
            Products Offered:
            <input
              type="text"
              name="products"
              value={formData.products}
              onChange={handleChange}
            />
          </label>

          <label>
            Delivery Capability:
            <input
              type="text"
              name="delivery"
              value={formData.delivery}
              onChange={handleChange}
            />
          </label>

          <label>
            Areas of Interest:
            <input
              type="text"
              name="interested"
              value={formData.interested}
              onChange={handleChange}
            />
          </label>

          <label>
            Remarks:
            <textarea
              name="remarks"
              value={formData.remarks}
              onChange={handleChange}
              rows="4"
            ></textarea>
          </label>

          <button type="submit">Submit</button>
        </form>
      </div>

      {/* Partner Slider */}
      <div className="ourpartners-slider">
        <div className="ourpartners-track">
          {partners.concat(partners).map((logo, index) => (
            <img
              key={index}
              src={logo}
              alt={`Partner ${index}`}
              className="ourpartners-logo"
            />
          ))}
        </div>
      </div>
    </div>
  );
}
